import { CHANGE_LOCALE } from 'store/LanguageProvider/constants';

export const changeLocaleLanguage = (
  locale: string,
): ChangeLocaleLanguageType => ({
  type: CHANGE_LOCALE,
  locale,
});

type ChangeLocaleLanguageType = {
  type: typeof CHANGE_LOCALE;
  locale: string;
};
